import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:5,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceAyrFlo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="University of Wisconsin School of Medicine and Public Health"
          subtitle="Research Specialist: March 2021-present, Madison, WI"
          avatar="images/uw.jpg"
          actAsExpander={true}
          //showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <div>
            <ul>
              <li>
                Business planning via the National Science Foundation's&nbsp;
                  <a href="https://www.nsf.gov/news/special_reports/i-corps/index.jsp" target="_blank" rel="noopener noreferrer">
                    I-Corps Program
                  </a>
              </li>
              <li>
                Product development research of a novel respiratory diagnostic monitor (
                  <a href="http://www.ayrflo-inc.com" target="_blank" rel="noopener noreferrer">
                    www.ayrflo-inc.com
                  </a>
                )
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  Business Model Canvas
                </Chip>
                <Chip style={styles.chip}>
                  Adobe Premiere
                </Chip>
                <Chip style={styles.chip}>
                  Adobe Illustrator
                </Chip>
              </div>
            </ul>
          </div>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceAyrFlo.js